// extracted by mini-css-extract-plugin
export default {"overlay":"CanvaDesignsList_overlay__Cb-U5"};